import React, { useContext } from 'react';
import { cx } from "../../../lib/theming/Emotion";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { isTheme2022 } from "../../../lib/theming/ThemeHelpers";
import { ArrowRightIcon } from "../ArrowRightIcon";
import { ArrowLeftIcon } from "../ArrowLeftIcon";
import { Button } from "../Button";
import { globalClasses, styles } from "../Button.styles";

var ButtonArrow = function ButtonArrow(_ref) {
  var arrow = _ref.arrow,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? Button.defaultProps.size : _ref$size,
      disabled = _ref.disabled,
      checked = _ref.checked,
      error = _ref.error,
      warning = _ref.warning,
      isFocused = _ref.isFocused;
  var theme = useContext(ThemeContext);

  var _isTheme2022 = isTheme2022(theme);

  var getArrowIconRootClassName = function getArrowIconRootClassName() {
    var _cx;

    return cx(styles.arrowIconRoot(), globalClasses.arrow, (_cx = {}, _cx[styles.arrowIconRootSmall(theme)] = size === 'small', _cx[styles.arrowIconRootMedium(theme)] = size === 'medium', _cx[styles.arrowIconRootLarge(theme)] = size === 'large', _cx[styles.arrowIconLeft()] = arrow === 'left', _cx));
  };

  var arrowNode = null;

  if (_isTheme2022) {
    var arrowIcons = {
      right: ArrowRightIcon,
      left: ArrowLeftIcon
    };
    var side = arrow === 'left' ? 'left' : 'right';
    var ArrowIcon = arrowIcons[side];
    arrowNode = /*#__PURE__*/React.createElement("div", {
      className: getArrowIconRootClassName()
    }, /*#__PURE__*/React.createElement(ArrowIcon, {
      size: size
    }));
  } else {
    var _cx2;

    arrowNode = /*#__PURE__*/React.createElement("div", {
      className: cx((_cx2 = {}, _cx2[styles.arrow()] = true, _cx2[styles.arrowWarning(theme)] = !checked && warning && !disabled, _cx2[styles.arrowError(theme)] = !checked && error && !disabled, _cx2[styles.arrowFocus(theme)] = !checked && isFocused && !disabled, _cx2[styles.arrowLeft()] = arrow === 'left', _cx2))
    }, /*#__PURE__*/React.createElement("div", {
      className: cx(globalClasses.arrowHelper, globalClasses.arrowHelperTop)
    }), /*#__PURE__*/React.createElement("div", {
      className: cx(globalClasses.arrowHelper, globalClasses.arrowHelperBottom)
    }));
  }

  return arrowNode;
};

export function useButtonArrow(props, theme) {
  var _cx3;

  var arrow = props.arrow,
      size = props.size,
      use = props.use;

  var _isTheme2022 = isTheme2022(theme);

  var canRender = use !== 'link' && (arrow === true || arrow === 'left');
  var rootClassName = !_isTheme2022 && canRender ? '' : cx(arrow === true && size === 'small' && styles.withArrowIconRightSmall(theme), arrow === true && size === 'medium' && styles.withArrowIconRightMedium(theme), arrow === true && size === 'large' && styles.withArrowIconRightLarge(theme), arrow === 'left' && size === 'small' && styles.withArrowIconLeftSmall(theme), arrow === 'left' && size === 'medium' && styles.withArrowIconLeftMedium(theme), arrow === 'left' && size === 'large' && styles.withArrowIconLeftLarge(theme));
  var wrapClassName = _isTheme2022 && canRender ? '' : cx((_cx3 = {}, _cx3[styles.wrapArrow()] = arrow === true, _cx3[styles.wrapArrowLeft()] = arrow === 'left', _cx3));
  var arrowNode = canRender ? /*#__PURE__*/React.createElement(ButtonArrow, props) : null;
  return [wrapClassName, rootClassName, arrowNode];
}